import { z } from 'zod'
import { AreaCodeSchema } from '../enums.js'

export const CoverageSchema = z.object({
  id: z.string().min(1),
  contract_id: z.string().min(1),
  area: AreaCodeSchema,
  sum_insured_czk: z.number().nonnegative(),
  deductible_czk: z.number().nonnegative().nullable().optional(),
})
export type Coverage = z.infer<typeof CoverageSchema>
